<template>
  <div id="app" class="download-page">
    <HeadNav
      selected-language="en"
      page="download"
      :gotodownload="gotodownload"
    />

    <main class="download-main">
      <section class="download-hero">
        <h1>Directly Download GB WhatsApp APK on Your Phone Now...</h1>
        <a href="/" class="download-hero-home" :title="site.siteName" rel="home">
          <img
            class="download-hero-logo"
            src="@/assets/gbwa-logo.webp"
            alt="GB WhatsApp APK download logo"
          >
        </a>
        <a class="primary-download" :href="site.apkUrl">
          <i class="fa fa-cloud-download-alt" aria-hidden="true"></i>
          Download GB WhatsApp APK
        </a>
      </section>

      <section class="download-section">
        <h2>How to Install GB WhatsApp on Android</h2>
        <ol class="step-timeline">
          <li
            v-for="(step, index) in installSteps"
            :key="index"
            class="step-timeline-item"
          >
            <div class="step-timeline-marker" aria-hidden="true">{{ index + 1 }}</div>
            <div class="step-timeline-body">
              <p
                class="step-timeline-text step-timeline-text--solo"
                v-html="step"
              ></p>
            </div>
          </li>
        </ol>
        <p class="section-note">
          If the installation fails, check whether an older version needs to be removed first or whether your Android version meets the minimum requirement
        </p>
      </section>

      <section class="download-section">
        <h2>Download Tips</h2>
        <p>To help avoid installation problems:</p>
        <ul class="guide-dot-list">
          <li v-for="tip in downloadTips" :key="tip">{{ tip }}</li>
        </ul>
      </section>
    </main>
  </div>
</template>

<script>
import '@/css/base.scss';
import '@/css/index.scss';
import '@/css/download.scss';
import HeadNav from '@/components/HeadNav.vue';
import site from '@/config/site.json';

export default {
  name: 'Download',
  components: {
    HeadNav,
  },
  data() {
    return {
      site,
      installSteps: [
        'Download the latest APK using the button above.',
        'Enable <strong>Install Unknown Apps</strong> if your device asks for permission.',
        'Open the downloaded APK file and complete the installation.',
        'Verify your phone number and restore your local backup if available.',
        'Start using the latest version.',
      ],
      downloadTips: [
        'Download the complete APK before opening it.',
        'Make sure you have enough storage space available.',
        'Keep a backup of your chats before updating.',
        'Install the latest available version instead of outdated releases whenever possible.',
      ],
    };
  },
  methods: {
    gotodownload() {
      if (typeof window !== 'undefined') {
        window.location.href = this.site.apkUrl;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.download-page {
  min-height: 100vh;
  background: #f6f8fb;
}

.download-main {
  width: min(980px, calc(100% - 30px));
  margin: 0 auto;
  padding: 28px 0 60px;
}

.download-hero {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 28px;
  padding: 40px 32px;
  border-radius: 8px;
  background: #fff;
  box-shadow: 0 8px 24px rgba(31, 53, 86, 0.06);
  text-align: center;
}

.download-hero h1 {
  margin: 0;
  max-width: 18em;
  color: #14213d;
  font-size: clamp(30px, 5vw, 44px);
  line-height: 1.2;
  letter-spacing: -0.01em;
}

.download-hero-home {
  display: block;
  line-height: 0;
}

.download-hero-logo {
  display: block;
  width: min(160px, 36vw);
  height: auto;
  object-fit: contain;
}

.primary-download {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  min-width: 260px;
  min-height: 54px;
  padding: 14px 28px;
  border-radius: 8px;
  background: #0b6d47;
  color: #fff !important;
  font-size: 17px;
  font-weight: 700;
  text-decoration: none;
  box-shadow: 0 8px 24px rgba(11, 109, 71, 0.22);
  transition: background 0.15s ease, box-shadow 0.15s ease;
}

.primary-download .fa {
  font-size: 1.05em;
}

.primary-download:hover,
.primary-download:focus {
  background: #0a5f3e;
  color: #fff !important;
  box-shadow: 0 10px 28px rgba(11, 109, 71, 0.28);
}

.download-section {
  margin-top: 22px;
  padding: 30px 32px;
  background: #fff;
  border-radius: 8px;
  box-shadow: 0 8px 24px rgba(31, 53, 86, 0.06);
}

.download-section h2 {
  margin: 0 0 18px;
  color: #14213d;
  font-size: 28px;
  line-height: 1.25;
  letter-spacing: 0;
}

.download-section p {
  margin: 0;
  color: #3c4b62;
  font-size: 16px;
  line-height: 1.7;
}

.section-note {
  margin-top: 18px;
}

.step-timeline {
  list-style: none;
  margin: 20px 0 0;
  padding: 0;
}

.step-timeline-item {
  position: relative;
  display: grid;
  grid-template-columns: 40px minmax(0, 1fr);
  gap: 16px;
  align-items: start;
  padding-bottom: 24px;
}

.step-timeline-item:last-child {
  padding-bottom: 0;
}

.step-timeline-item:not(:last-child)::after {
  position: absolute;
  top: 40px;
  bottom: 0;
  left: 20px;
  width: 2px;
  background: linear-gradient(180deg, #b8e6cf 0%, #e5f5ec 100%);
  content: '';
  transform: translateX(-50%);
}

.step-timeline-marker {
  position: relative;
  z-index: 1;
  display: grid;
  place-items: center;
  justify-self: center;
  box-sizing: border-box;
  width: 40px;
  height: 40px;
  border: 2px solid #9dd4b8;
  border-radius: 50%;
  background: #f4fbf7;
  color: #0b6d47;
  font-size: 15px;
  font-weight: 700;
  line-height: 1;
  font-variant-numeric: tabular-nums;
}

.step-timeline-body {
  padding-top: 8px;
}

.step-timeline-text {
  margin: 6px 0 0;
  color: #3c4b62;
  font-size: 15px;
  line-height: 1.65;
}

.step-timeline-text--solo {
  margin: 0;
  padding-top: 2px;
  font-size: 16px;
  line-height: 1.7;
}

.step-timeline-text strong {
  color: #14213d;
  font-weight: 700;
}

.guide-dot-list {
  list-style: none !important;
  margin: 12px 0 0 !important;
  padding: 0 !important;
}

.guide-dot-list li {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 10px;
  padding-left: 0;
  list-style: none !important;
  color: #3c4b62;
  font-size: 16px;
  line-height: 1.7;
}

.guide-dot-list li::before {
  flex: 0 0 6px;
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background: #2563eb;
  content: '';
}

.guide-dot-list li::marker {
  content: '';
}

.guide-dot-list li:last-child {
  margin-bottom: 0;
}

@media (max-width: 640px) {
  .download-main {
    width: min(100% - 20px, 980px);
    padding-top: 10px;
  }

  .download-hero,
  .download-section {
    padding: 28px 20px;
  }

  .download-hero {
    gap: 22px;
  }

  .download-hero h1 {
    font-size: 28px;
  }

  .primary-download {
    width: 100%;
    max-width: 320px;
  }
}
</style>
